import { CreateContratPage } from "@features/rh/contrats/components/CreateContratPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FilePlus } from "lucide-react";
import { z } from "zod";

const searchSchema = z.object({
  personneId: z.number().optional(),
});

export const Route = createFileRoute("/_app/rh/contrats/create")({
  loader: requirePermission(PERMISSIONS.RH.CONTRATS.CREATE),
  staticData: {
    title: "Ajouter un contrat",
    icon: FilePlus,
    permission: PERMISSIONS.RH.CONTRATS.CREATE,
    section: "App",
    showInBreadcrumb: true,
  },
  validateSearch: searchSchema,
  component: CreateContratPage,
});
